import React from "react";
import { Link } from "react-router-dom";

/**
 * Landing page footer
 */
export function LandingFooter() {
  return (
    <footer className="border-t border-border py-12 bg-secondary/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img src="/logo-new.png" alt="Setuxpress" className="h-8" />
              
            </Link>
            <p className="text-sm text-muted-foreground">
              India's first cargo space sharing platform. Connecting logistics partners with shippers.
            </p>
          </div>
          
          <div>
            <h4 className="font-bold mb-4">Services</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/browse" className="hover:text-foreground transition-colors">Cargo Space</Link></li>
              <li><Link to="/local-delivery" className="hover:text-foreground transition-colors">Local Delivery</Link></li>
              <li><Link to="/private-jets" className="hover:text-foreground transition-colors">Private Jets</Link></li>
              <li><Link to="/carpool" className="hover:text-foreground transition-colors">Carpool</Link></li>
              <li><Link to="/bulk-booking" className="hover:text-foreground transition-colors">Bulk Booking</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold mb-4">Company</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><a href="#" className="hover:text-foreground transition-colors">About Us</a></li>
              <li><a href="#" className="hover:text-foreground transition-colors">Contact</a></li>
              <li><a href="#" className="hover:text-foreground transition-colors">Careers</a></li>
              <li><Link to="/admin-login" className="hover:text-foreground transition-colors">Admin Portal</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><a href="#" className="hover:text-foreground transition-colors">Terms of Service</a></li>
              <li><a href="#" className="hover:text-foreground transition-colors">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-foreground transition-colors">Refund Policy</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-border mt-8 pt-8 text-center text-sm text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} Setuxpress. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
